import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarContratanteRequest } from '../../models/cotizador-contratante/consultar-contratante/request/consultar-contratante-request.model';
import { ConsultarContratanteResponse } from '../../models/cotizador-contratante/consultar-contratante/response/consultar-contratante-response.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarContratanteService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CONSULTAR_DATOS_USUARIO}`;

  constructor(private httpClient: HttpClient) { }

  consultarContratante(request: ConsultarContratanteRequest): Observable<ConsultarContratanteResponse> {
    return this.httpClient.post<ConsultarContratanteResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarContratante: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar datos del contratante'));
      })
    );
  }
}
